import * as React from "react";

;
export const More = (props: React.SVGProps<SVGSVGElement>) => <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M4 12a2 2 0 11-4 0 2 2 0 014 0zM14 12a2 2 0 11-4 0 2 2 0 014 0zM22 14a2 2 0 100-4 2 2 0 000 4z" fill="#100722" /></svg>;